const state = {
  history: [],
  newHistory: [],
  historyIndex: -1,
}

export default state
